module.exports = __webpack_public_path__ + "static/img/background-loading.90012963.svg";